import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
  border: 1px solid ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primary_light};
}

form{
  display: flex;
  flex-direction:row;
  align-items: flex-start;
  justify-content:flex-start;
  margin-top: 15px;
  width:100%;
  label {
    display:flex;
    align-items:center;
    height: 20px;
    width: 80px;
    margin-top:5px;
  }
  input, select, option {
    height: 30px;
    width: 200px;
    font-size: 16px;
  }
  button{
    margin-top:-5px;
    margin-left:20px;
    display:flex;
    align-items:center;
  }
}



`